const TOPICS = [
  { label: '韩漫推荐', heat: '火热', count: '2.3万讨论' },
  { label: '日漫经典', heat: '热门', count: '1.8万讨论' },
  { label: '国漫崛起', heat: '热门', count: '1.6万讨论' },
  { label: '下拉式追更', heat: '火热', count: '3.1万讨论' },
  { label: '恋爱漫画', heat: '热门', count: '2.7万讨论' },
  { label: '玄幻修仙', heat: '热门', count: '1.5万讨论' },
  { label: '悬疑烧脑', heat: '推荐', count: '9800讨论' },
  { label: '免费全集', heat: '火热', count: '4.2万讨论' },
  { label: '新番速递', heat: '推荐', count: '7600讨论' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            漫画迷们正在热烈讨论的话题，加入交流分享你的追更心得
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {TOPICS.map((t, i) => (
            <a
              key={i}
              href="#comments"
              className="group inline-flex items-center gap-3 px-5 py-3 bg-background-100 hover:bg-background-200/70 rounded-full border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <span
                className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                  t.heat === '火热'
                    ? 'bg-accent-100 text-accent-700'
                    : t.heat === '热门'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-secondary-100 text-secondary-700'
                }`}
              >
                {t.heat}
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                {t.label}
              </span>
              <span className="text-xs text-foreground-400">{t.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}